import { useContext } from 'react';
import StaffRibbon from 'edrolo/domains/app/components/StaffRibbon';
import { CLASS_POSITION, FEATURE_SET } from 'edrolo/domains/profile';
import {
  getShowUnpublished,
  getStaffFeatureSetOverride,
  getStaffPositionOverride,
  setShowUnpublished,
  setStaffFeatureSetOverride,
  setStaffPositionOverride,
} from 'edrolo/domains/utils/staffOverrideUtils';
import { ClassContext } from 'edrolo/context';

/*
 * Implements tools allowing Edrolo staff to toggle different parts of
 * the UI on/off for QA purposes. State is managed in browser cookies because
 * it often has to persist across pages/routes and between page loads. State
 * is made available via a React context.
 */
export const CoursePortalStaffRibbon = () => {
  const currentFeatureSetOverride: string = getStaffFeatureSetOverride() || '';

  const {
    data: { forceRerender },
  } = useContext(ClassContext);

  const {
    data: { assemblage, classId },
  } = useContext(ClassContext);

  const courseId = assemblage.course.id;

  return (
    <StaffRibbon classId={classId}>
      <li>
        <input
          type="checkbox"
          id="admin-show-unpublished-checkbox"
          name="admin-show-unpublished_checkbox"
          checked={!!getShowUnpublished()}
          onChange={(e) => {
            setShowUnpublished(e.target.checked);
            forceRerender();
          }}
        />
        <label htmlFor="admin-show-unpublished-checkbox">
          Show Unpublished
        </label>
      </li>
      <li>
        <select
          value={getStaffPositionOverride() || CLASS_POSITION.STUDENT}
          onChange={(e) => {
            setStaffPositionOverride(e.target.value, false);
            forceRerender();
          }}
        >
          <option value={CLASS_POSITION.STUDENT}>Student</option>
          <option value={CLASS_POSITION.TEACHER}>Teacher</option>
        </select>
      </li>
      <li>
        <select
          value={
            Object.keys(FEATURE_SET).includes(currentFeatureSetOverride)
              ? currentFeatureSetOverride
              : FEATURE_SET.STANDARD
          }
          onChange={(e) => setStaffFeatureSetOverride(e.target.value)}
        >
          <option value={FEATURE_SET.STANDARD}>Standard</option>
          <option value={FEATURE_SET.EXTENDED}>Extended</option>
          <option value={FEATURE_SET.EXTENDED_TEXTBOOK}>
            Extended w/Textbook
          </option>
        </select>
      </li>
      <StaffRibbon.Link
        key="cpt"
        title="Edit in CPT Tools"
        url={`/content/admin/courses/edit/${courseId}/`}
        analyticsPayload={{ course_id: courseId }}
      />
      <StaffRibbon.Link
        key="admin"
        title="Edit in Admin"
        url={`/secret/tod/branch/${courseId}/change/`}
        analyticsPayload={{ course_id: courseId }}
      />
      <StaffRibbon.Link
        key="classes"
        title="Classes for this course"
        url={`/secret/profiles/schoolclass/?course_id=${courseId}`}
        analyticsPayload={{ course_id: courseId }}
      />
    </StaffRibbon>
  );
};
